/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ProductUploadHistoryRequestDTOStatusesEnum = {
    Ready: 'READY',
    Pending: 'PENDING',
    Submitted: 'SUBMITTED',
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
};
/**
 * Check if a given object implements the ProductUploadHistoryRequestDTO interface.
 */
export function instanceOfProductUploadHistoryRequestDTO(value) {
    return true;
}
export function ProductUploadHistoryRequestDTOFromJSON(json) {
    return ProductUploadHistoryRequestDTOFromJSONTyped(json, false);
}
export function ProductUploadHistoryRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fromDate': json['fromDate'] == null ? undefined : (new Date(json['fromDate'])),
        'toDate': json['toDate'] == null ? undefined : (new Date(json['toDate'])),
        'marketplaces': json['marketplaces'] == null ? undefined : json['marketplaces'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'page': json['page'] == null ? undefined : json['page'],
        'size': json['size'] == null ? undefined : json['size'],
    };
}
export function ProductUploadHistoryRequestDTOToJSON(json) {
    return ProductUploadHistoryRequestDTOToJSONTyped(json, false);
}
export function ProductUploadHistoryRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fromDate': value['fromDate'] == null ? undefined : ((value['fromDate']).toISOString()),
        'toDate': value['toDate'] == null ? undefined : ((value['toDate']).toISOString()),
        'marketplaces': value['marketplaces'],
        'statuses': value['statuses'],
        'asin': value['asin'],
        'page': value['page'],
        'size': value['size'],
    };
}
